import * as i0 from '@angular/core';
import { Component, Optional, Self, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldControl } from '@angular/material/form-field';

class CheckboxGroupComponent {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.disabled = false;
        // This setup would otherwise be handled by the NG_VALUE_ACCESSOR
        // provider, but this causes problems with the MatFormFieldControl.
        if (this.ngControl !== null) {
            this.ngControl.valueAccessor = this;
        }
    }
    writeValue(v) {
        this.value = v;
    }
    registerOnChange(fn) {
        this.onChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    change(c) {
        this.onChanged(this.value);
        this.onTouched(this.value);
    }
    getValueKeys() {
        return this.value ? Object.keys(this.value) : [];
    }
}
CheckboxGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CheckboxGroupComponent, deps: [{ token: i1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
CheckboxGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: CheckboxGroupComponent, selector: "checkbox-group", providers: [
        // { 
        //   provide: NG_VALUE_ACCESSOR,
        //   useExisting: forwardRef(() => CheckboxGroupComponent),
        //   multi: true
        // }
        {
            provide: MatFormFieldControl,
            useExisting: CheckboxGroupComponent,
        },
    ], ngImport: i0, template: "<div fxLayout=\"row\">\n\n  <div *ngFor=\"let k of getValueKeys()\">\n    <mat-checkbox\n    [(ngModel)]=\"value[k].model\"\n    (ngModelChange)=\"change(value[k])\">\n      {{value[k].name}}\n    </mat-checkbox>\n  </div>\n\n</div>", styles: [""], components: [{ type: i2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'checkbox-group', providers: [
                        // { 
                        //   provide: NG_VALUE_ACCESSOR,
                        //   useExisting: forwardRef(() => CheckboxGroupComponent),
                        //   multi: true
                        // }
                        {
                            provide: MatFormFieldControl,
                            useExisting: CheckboxGroupComponent,
                        },
                    ], template: "<div fxLayout=\"row\">\n\n  <div *ngFor=\"let k of getValueKeys()\">\n    <mat-checkbox\n    [(ngModel)]=\"value[k].model\"\n    (ngModelChange)=\"change(value[k])\">\n      {{value[k].name}}\n    </mat-checkbox>\n  </div>\n\n</div>", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    } });

class MatUtilModule {
}
MatUtilModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MatUtilModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MatUtilModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MatUtilModule, declarations: [CheckboxGroupComponent], imports: [FormsModule,
        CommonModule,
        ReactiveFormsModule,
        MatCheckboxModule], exports: [CheckboxGroupComponent] });
MatUtilModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MatUtilModule, imports: [[
            FormsModule,
            CommonModule,
            ReactiveFormsModule,
            MatCheckboxModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MatUtilModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CheckboxGroupComponent,
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        ReactiveFormsModule,
                        MatCheckboxModule
                    ],
                    exports: [
                        CheckboxGroupComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of mat-util
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CheckboxGroupComponent, MatUtilModule };
